import { flow, getEnv, Instance, types } from 'mobx-state-tree';

import PotentialPrintProblemsModel from './PotentialPrintProblemsModel';
import { AdvancedStoreEnv } from './StoreEnv';

const PotentialPrintProblemsStore = types
  .model('PotentialPrintProblemsStore', {
    loadingState: types.maybe(types.enumeration(['loading', 'error'])),
    potentialPrintProblems: types.maybe(PotentialPrintProblemsModel)
  })
  .actions((self) => {
    const getPotentialPrintProblems = flow(function* () {
      const { client, applicationStore } = getEnv<AdvancedStoreEnv>(self);

      self.loadingState = 'loading';

      try {
        const potentialPrintProblems = yield client.getPotentialPrintProblems();

        self.potentialPrintProblems = potentialPrintProblems;

        self.loadingState = undefined;

        return self.potentialPrintProblems;
      } catch (error: any) {
        if (process.env.NODE_ENV !== 'production') {
          console.error(
            'PotentialPrintProblemsStore | getPotentialPrintProblems',
            error,
            error.body
          );
        }

        if (applicationStore.handleAppError(error)) {
          return;
        }

        self.loadingState = 'error';

        throw error;
      }
    });

    return { getPotentialPrintProblems };
  });

export type PotentialPrintProblemsStoreType = Instance<
  typeof PotentialPrintProblemsStore
>;

export default PotentialPrintProblemsStore;
